<template>
  <div>
    <PageHeader :items="items" :optionalItems="optionalItems">
      <template #filters>
        <div class="search-filters">
          <SearchFilter :isFilterSearch="false">
            <li>
              <div
                class="filter-trigger d-flex align-items-center"
                @click="$refs.filterModal.$refs.modal.show()"
              >
                <feather-icon class="stroke-icon" :icon="'FilterIcon'" size="16" />
                <span>{{ $t("filters") }}</span>
              </div>
            </li>
          </SearchFilter>
          <div class="page-header-search">
            <input
              autocomplete="off"
              type="text"
              name="search"
              :placeholder="$t('search')"
              v-model="form.search"
            />
            <button class="" type="button" @click="reset">
              {{ $t("reset") }}
            </button>
          </div>
        </div>
      </template>
      <template #buttons>
        <button
          @click="downloadCsv()"
          class="btn btn-primary d-flex align-items-center gap-1"
        >
          <feather-icon class="stroke-icon" :icon="'DownloadIcon'" size="12" />
          <span>{{ $t("downloadTemplateForImport") }}</span>
        </button>
        <button
          @click="$refs.fileInput.click()"
          class="btn btn-primary d-flex align-items-center gap-1"
          v-if="$can(`${$route.meta.permission}.import-csv`)"
        >
          <feather-icon class="stroke-icon" :icon="'UploadIcon'" size="12" />
          <span>{{ $t("importCsv") }}</span>
        </button>
        <button
          v-if="$can(`backoffice.company.create-report`)"
          @click="downloadReport()"
          class="btn btn-primary d-flex align-items-center gap-1"
        >
          <feather-icon class="stroke-icon" :icon="'DownloadIcon'" size="12" />
          <span>{{ $t("createReport") }}</span>
        </button>
        <input
          style="display: none"
          type="file"
          @change="handleFileUpload"
          accept=".csv"
          ref="fileInput"
        />
      </template>
    </PageHeader>

    <!--==================================-->
    <!--==================================-->
    <div class="dextop-table-view">
      <!-- table -->
      <div class="table-responsive api-keys-table">
        <vue-good-table
          styleClass="vgt-table striped"
          :columns="columns"
          :fixed-header="false"
          :rows="rows"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
            trigger: 'enter',
          }"
          :pagination-options="{
            enabled: false,
            perPage: pageLength,
          }"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-per-page-change="onPerPageChange"
        >
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->

            <span
              class="d-flex align-items-center justify-content-center gap-2"
              v-if="props.column.field === 'action'"
            >
              <div
                class="cursor-pointer"
                @click="$router.push(`/customers/${props.row.id}/show`)"
                v-if="
                  $can(`${$route.meta.permission}.list`) ||
                  $can(`${$route.meta.permission}.show-all`)
                "
              >
                <feather-icon size="16" icon="EyeIcon" />
              </div>
              <div
                class="cursor-pointer"
                v-if="$can(`${$route.meta.permission}.edit`)"
                @click="$router.push(`/customers/${props.row.id}/edit`)"
              >
                <feather-icon size="16" icon="Edit2Icon" />
              </div>
              <div
                v-if="$can(`${$route.meta.permission}.delete`)"
                class="cursor-pointer"
                @click="destroy(props.row.id)"
              >
                <feather-icon size="16" icon="TrashIcon" />
              </div>
            </span>
            <span v-else-if="props.column.field === 'createdAt'">
              <p class="">
                {{ $dateFormatter(props.row.createdAt, $i18n.locale) }}
              </p>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <b-form-group>
          <div class="d-flex align-items-center">
            <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
            <b-form-select
              v-model="pageLength"
              :options="['25', '50', '100']"
              class="ml-1"
              @input="(value) => onPerPageChange({ pageLength: value })"
            />
          </div>
        </b-form-group>
        <div>
          <b-pagination
            :value="1"
            :total-rows="totalRecords"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="(value) => onPageChange({ currentPage: value })"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </div>
    <!--==================================-->
    <!--==================================-->
    <div class="reponsive-view-cards">
      <div class="row">
        <div class="col-md-6" v-for="row in rows" :key="row.id">
          <div class="card mb-1">
            <div
              class="card-header d-flex align-items-center justify-content-between"
            >
              <h5 class="card-title">{{ row.companyNumber }}</h5>

              <div class="d-flex gap-3">
                <div
                  class="cursor-pointer"
                  @click="$router.push(`/customers/${row.id}/show`)"
                  v-if="
                    $can(`${$route.meta.permission}.list`) ||
                    $can(`${$route.meta.permission}.show-all`)
                  "
                >
                  <feather-icon size="18" icon="EyeIcon" />
                </div>
                <div
                  class="cursor-pointer"
                  v-if="$can(`${$route.meta.permission}.edit`)"
                  @click="$router.push(`/customers/${row.id}/edit`)"
                >
                  <feather-icon size="18" icon="Edit2Icon" />
                </div>
                <div
                  class="cursor-pointer"
                  v-if="$can(`${$route.meta.permission}.delete`)"
                  @click="destroy(row.id)"
                >
                  <feather-icon size="18" icon="TrashIcon" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <ul class="card-list">
                <li class="align-items-start">
                  <div class="left pr-1">
                    <strong>{{ $t("companyName") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.companyName }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("vat") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.vatId }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("city") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.city }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("country") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.country }}</span>
                  </div>
                </li>
                <!-- <li> 
                  <div class="left">
                    <strong>{{ $t("dentalTwinCredits") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.credits }}</span>
                  </div>
                </li> -->
                <li>
                  <div class="left">
                    <strong>{{ $t("status") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.status }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("registrationDate") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ $dateFormatter(row.createdAt, $i18n.locale) }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("totalCases") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.totalCases }}</span>
                  </div>
                </li>
                <li>
                  <div class="left">
                    <strong>{{ $t("paidCases") }}: </strong>
                  </div>
                  <div class="right">
                    <span>{{ row.paidCases }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination at the bottom -->
      <div class="d-flex justify-content-center mt-2">
        <b-pagination
          :value="1"
          :total-rows="totalRecords"
          :per-page="pageLength"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @input="(value) => onPageChange({ currentPage: value })"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
    <!--====================================-->
    
    <!-- Filter Modal -->
    <CustomerFilterModal
      ref="filterModal"
      :filters="form"
      :selectedColumns="selectedColumns"
      :statusOptions="statusOptions"
      :allColumns="allColumns"
      :companyStatusOptions="companyStatusOptions"
      @apply-filters="handleApplyFilters"
      @column-change="handleColumnChange"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import NotificationService from "@/services/notification.service";
import { debounce } from "@/utils/debounce";
import { mapGetters } from "vuex";
import MultiSelect from "vue-multiselect";
import SearchFilter from "@/components/SearchFilter.vue";
import CustomerFilterModal from "@/components/CustomerFilterModal.vue";

export default {
  components: {
    PageHeader,
    MultiSelect,
    NotificationService,
    SearchFilter,
    CustomerFilterModal,
  },
  computed: {
    allColumns() {
      return [
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("companyNumber"),
          field: "companyNumber",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("companyName"),
          field: "companyName",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("vat"),
          field: "vatId",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("city"),
          field: "city",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("country"),
          field: "country",
        },
        // {
        //   tdClass: "vgt-left-align",
        //   thClass: "vgt-left-align",
        //   label: this.$t("dentalTwinCredits"),
        //   field: "credits",
        // },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("status"),
          field: "status",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("registrationDate"),
          field: "createdAt",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("totalCases"),
          field: "totalCases",
        },
        {
          tdClass: "vgt-left-align",
          thClass: "vgt-left-align",
          label: this.$t("paidCases"),
          field: "paidCases",
        },
        {
          tdClass: "vgt-center-align",
          thClass: "vgt-center-align",
          label: this.$t("action"),
          field: "action",
          sortable: false,
        },
      ];
    },
    optionalItems() {
      return {
        createBtn1: {
          show: true,
          text: this.$t("createCustomer"),
          icon: "PlusIcon",
          path: "/customers/create",
          permission: "backoffice-company.create",
        },
      };
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("customers"),
          active: true,
        },
      ];
    },
    statusOptions() {
      return [
        {
          title: this.$t("commercialAgent"),
          id: "commercial_agent",
        },
        {
          title: this.$t("salesPartner"),
          id: "sales_partner",
        },
        {
          title: this.$t("affiliate"),
          id: "affiliate",
        },
      ];
    },
    companyStatusOptions() {
      return [
        {
          title: this.$t("new"),
          id: "new",
        },
        {
          title: this.$t("test"),
          id: "test",
        },
        {
          title: this.$t("active"),
          id: "active",
        },
      ];
    },
    columns() {
      // Preserve the original order defined in allColumns
      return this.allColumns.filter((col) =>
        this.selectedColumns.some((sel) => sel.field === col.field)
      );
    },
    selectedColumns() {
      return this.allColumns.filter((col) =>
        this.selectedColumnFields.includes(col.field)
      );
    },
  },
  data() {
    return {
      selectedColumnFields: [],
      file: null,
      totalRecords: 0,
      pageLength: 25,
      page: 1,
      form: {
        customerType: [],
        companyStatus: [],
        search: "",
        freeCasesMin: null,
        freeCasesMax: null,
        lastCaseCreation: null,
      },
      sortBy: "createdAt",
      sortOrder: "desc",
      rows: [],
      searchTerm: "",
    };
  },

  async created() {
    this.debouncedFetch = debounce(async (newValue, oldValue) => {
      try {
        await this.loadItems();
      } catch (e) {
        console.error(e);
      }
    }, 300);
    this.selectedColumnFields = this.allColumns.map((c) => c.field);
    this.loadItems();
  },
  watch: {
    form: {
      handler() {
        this.debouncedFetch();
      },
      deep: true,
    },
  },

  methods: {
    async handleFileUpload(event) {
      this.file = event.target.files[0];
      if (this.file) {
        await this.importCsv();
      }
      // Reset the input value regardless of success/failure
      event.target.value = "";
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },

    async importCsv() {
      if (this.file) {
        const formData = new FormData();
        formData.append("file", this.file);
        this.$store.commit("showLoader", true);
        await this.$store
          .dispatch("customers/importCsv", formData)
          .then((res) => {
            this.loadItems();
            this.$refs.fileInput.value = "";
            this.file = null;
          })
          .finally(() => {
            this.$store.commit("showLoader", false);
            this.$refs.fileInput.value = "";
            this.file = null;
          });
      } else {
        NotificationService.showError("Please upload the csv file");
      }
    },

    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },

    onSortChange(params) {
      this.sortOrder = params[0].type;
      if (params[0].type == "none") this.sortOrder = "asc";
      this.sortBy = params[0].field;
      this.loadItems();
    },
    async downloadReport() {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("customers/download");
    },
    downloadCsv() {
      // Define CSV headers and a dummy row
      const headers = [
        "company_name",
        "vat_id",
        "address_line_1",
        "address_line_2",
        "city",
        "country",
        "zip_code",
        "phone",
        // "credits",
        "invoice_email",
        "warning_email_address",
        "apply_reverse_charge",
        "external_order_number",
        "Salespartner",
        "Reseller",
        "Servicepartner",
        "Is Salespartner",
        "Is Commercialagent",
        "Is Affiliate",

        // "Is Reseller",
        // "Is Servicepartner",
        // "Is Endkunde",
      ];

      const dummyRow = [
        "dummy name",
        "823594",
        "Address 1",
        "Address 2",
        "dummy city",
        "dummy country",
        "56234",
        "+84235324",
        // "0.00",
        "dummy@gmail.com",
        "dummy address",
        0,
        "R34354",
        "1234",
        "1234",
        "1234",
        0,
        0,
        0,
        0,
        0,
        // 0,
      ];

      // Create a CSV string
      const csvContent = [headers, dummyRow].map((e) => e.join(",")).join("\n");

      // Create a Blob from the CSV string
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "companies.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up the URL object
    },
    // load items is what brings back the rows from server
    async loadItems() {
      try {
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch("customers/list", {
          page: this.page,
          customerType:
            this.form.customerType.map((item) => {
              return item.id;
            }) || [],
          search: this.form.search,
          companyStatus: this.form.companyStatus.map((item) => {
            return item.id;
          }) || [],
          freeCasesMin: this.form.freeCasesMin,
          freeCasesMax: this.form.freeCasesMax,
          lastCaseCreation: this.form.lastCaseCreation,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          perPage: this.pageLength,
        });
        this.rows = response?.data?.data;
        this.totalRecords = response?.data?.total;
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    reset() {
      this.form.customerType = [];
      this.selectedColumns = [...this.allColumns];
      this.form.companyStatus = [];
      this.form.search = "";
      this.form.freeCasesMin = null;
      this.form.freeCasesMax = null;
      this.form.lastCaseCreation = null;
    },
    handleApplyFilters(filters) {
      this.form = { ...this.form, ...filters };
      if (filters.selectedColumns) {
        this.selectedColumnFields = filters.selectedColumns.map((c) => c.field);
      }
    },
    handleColumnChange(selectedColumns) {
      this.selectedColumnFields = selectedColumns.map((c) => c.field);
    },
    async destroy(id) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        await this.$store.dispatch("customers/destroy", id).finally(() => {
          this.loadItems();
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
